import { Collection } from 'modules/core/lib/mobx-rest'

import { ReportShare } from 'modules/reports/store/models/ReportShare'
import { ResourceTypes } from 'modules/reports/store/models/Share'

class ReportShares extends Collection<ReportShare> {
  url() {
    return '/permissions/shares'
  }
  model() {
    return ReportShare
  }
  get primaryKey() {
    return 'id'
  }
  get indexes() {
    return ['resource_id']
  }

  async fetch<T = ReportShare[]>(): Promise<T> {
    return super.fetch<T>({
      path: `${this.url()}/for_me`,
      data: { resource_type: ResourceTypes.Report },
    })
  }

  async fetchForReport(reportId: number): Promise<ReportShare[]> {
    await super.fetch<ReportShare[]>({
      path: `${this.url()}/for_resource`,
      data: { resource_type: ResourceTypes.Report, resource_id: reportId.toString() },
    })

    return this.ofReport(reportId)
  }

  ofReport(id: number): ReportShare[] {
    return this.filter({ resource_id: id.toString() })
  }
}

const singleton = new ReportShares()

export { singleton as ReportShares }
